import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import LinkEventBox from "./LinkEventBox";
import {
  setRunningData,
  addSelectedData,
  setMarketName,
} from "../../../AsianExchangeSrc/redux/slices/fullmarketSlice";
import { MdAlarmOn } from "react-icons/md";

const SportsCard = ({ cricketMatches, MatchName }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate(); // This is correctly imported and initialized

  const handleDataClick = (teamName, odds, type) => {
    const newData = {
      teamName,
      odds,
      oddsType: type,
    };
    dispatch(addSelectedData(newData));
  };

  const toggleDropdown = (id) => {
    const element = document.getElementById(`sub-${id}`);
    if (element) {
      element.classList.toggle("onsub");
    }
  };

  const handleMarket = (runningData, markets, href) => {
    try {
      dispatch(setRunningData(runningData));
      // Assuming setMarketName is another action creator you need to import
      dispatch(setMarketName(markets));
      navigate(href); // Navigate should be called last after state updates
    } catch (error) {
      console.error("Navigation error:", error);
    }
  };

  return (
    <>
      <ul className="dropdownul">
        <li onClick={() => toggleDropdown("cricket")}>{MatchName}</li>
        <div className="subdropdown" id="sub-cricket">
          <div className="slip-head">
            <div className="slip-head-one">
              <p>Matched</p>
            </div>

            <div className="slip-head-two">
              <div className="slip-head-two-item">1</div>
              <div className="slip-head-two-item">x</div>
              <div className="slip-head-two-item">2</div>
              <div className="item-book"></div>
            </div>
          </div>

          {cricketMatches?.data
            ?.slice()
            ?.sort((a, b) => {
              const aInPlay = a?.matchOdds?.some((odds) => odds?.inplay);
              const bInPlay = b?.matchOdds?.some((odds) => odds?.inplay);
              if (bInPlay && !aInPlay) return 1;
              if (aInPlay && !bInPlay) return -1;
              return 0;
            })
            .map((e, i) => {
              const filteredOdds = e?.matchOdds?.find(
                (odds) => odds?.marketId === e?.marketId
              );
              if (e?.marketName !== "Match Odds") {
                return null;
              }

              return (
                <div className="innerlink2" key={i}>
                  <div className="linkbox">
                    <div className="innerlink">
                      <Link
                        to={`/fullMarket?eventType=${e?.sportId}&eventId=${e?.eventId}&marketId=${e?.marketId}&joinedMarketIds=${e?.joinedMarketIds}&competitionId=${e?.competitionId}&bm=${e?.bm}&fancy=${e?.fancy}&pc=${e.pc}&eventName=${e.eventName}`}
                        onClick={(event) => {
                          event.preventDefault(); // Prevent default Link behavior
                          handleMarket(
                            e?.matchRunners,
                            e?.markets,
                            `/fullMarket?eventType=${e?.sportId}&eventId=${e?.eventId}&marketId=${e?.marketId}&joinedMarketIds=${e?.joinedMarketIds}&competitionId=${e?.competitionId}&bm=${e?.bm}&fancy=${e?.fancy}&pc=${e.pc}&eventName=${e.eventName}`
                          );
                        }}
                      >
                        {/* <img className="icon-in_play" src={dots} alt="dots" />{" "} */}
                        <div className={`rounded-full h-2 w-2 border-[0.5] border-black ${e?.matchOdds?.some((odds) => odds?.inplay) ? "bg-[#6bbd0f]" : "bg-[#c5d0d8]"}`} />

                        <b className="truncate max-w-[calc(100vw_-_65px)] md:max-w-[350px] overflow-hidden whitespace-nowrap">
                          {e?.eventName}
                        </b>
                      </Link>

                      <p>
                        {e?.matchOdds?.some((odds) => odds?.inplay) && (
                          <div className="play-btn"></div>
                        )}

                        {e?.fancy && (
                          <div className="bm-obds-icon">
                            <div className="bm-alam">
                              <MdAlarmOn />
                            </div>
                            <div className="bm-icon">F</div>
                          </div>
                        )}

                        {e?.bm && (
                          <div className="bm-obds-icon">
                            <div className="bm-alam">
                              <MdAlarmOn />
                            </div>
                            <div className="bm-icon">B</div>
                          </div>
                        )}

                        {e?.pc && (
                          <div className="bm-obds-icon premium-cricket">
                            
                            <div className="bm-icon">P</div>
                          </div>
                        )}

                        {e?.matchOdds?.some((odds) => odds?.inplay) && (
                          <span>In-Play</span>
                        )}
                      </p>
                    </div>

                    <div className="Matched-details">
                      <p>PTE---</p>
                    </div>
                  </div>

                  <LinkEventBox
                    eventName={e?.eventName}
                    filteredOdds={filteredOdds}
                    e={e}
                    handleDataClick={handleDataClick}
                    eventId={i}
                  />
                </div>
              );
            })}
        </div>
      </ul>
    </>
  );
};

export default SportsCard;
